// import lib
import { lazy } from "react";

const routes = [
  {
    role: "ROLE_FULLFILLMENT_CENTER",
    path: "/",
    element: lazy(() => import("../pages/SignIn")),
    noLayout: true,
  },
  {
    path: "/reset-password",
    element: lazy(() => import("../pages/SignIn/resetPassword")),
    noLayout: true,
  },
];

export default routes;
